// Animation configurations for IRON SLAMMING feel
// "This isn't a meditation app. This is where iron meets willpower."

// Custom easing for heavy grind effect (slow start, strong finish)
import { Easing } from 'react-native';

export const SLAM = { 
  tension: 300, 
  friction: 10, 
  useNativeDriver: false 
};

export const HEAVY = { 
  tension: 120, 
  friction: 14, 
  useNativeDriver: false 
};

export const GRIND_MS = 2000;
export const SNAP_MS = 150;

export const GRIND_EASING = Easing.bezier(0.1, 0.0, 0.2, 1.0);

// Animation sequences
export const TITLE_SLAM = {
  from: { translateY: -40, opacity: 0 },
  to: { translateY: 0, opacity: 1 },
  config: SLAM,
  delay: 0
};

export const BODY_FADE = {
  from: { opacity: 0 },
  to: { opacity: 1 },
  duration: 150,
  delay: 200
};

export const BUTTON_SNAP = {
  from: { scaleX: 0.3, opacity: 0 },
  to: { scaleX: 1.0, opacity: 1 },
  config: SLAM,
  delay: 350
};

export const HERO_SLIDE = {
  from: { translateY: 30, opacity: 0 },
  to: { translateY: 0, opacity: 1 },
  config: { tension: 200, friction: 12, useNativeDriver: false }
};

export const STAT_STAGGER = {
  from: { opacity: 0, translateY: 15 },
  to: { opacity: 1, translateY: 0 },
  duration: 300
};

export const HEARTBEAT_PULSE = {
  from: { scale: 1.0 },
  to: { scale: 1.05 },
  duration: 100,
  returnDuration: 900
};